module.exports = __webpack_public_path__ + "fb4ec87d51ddbe7c5d2f9e8f09d7e39f.ttf";